module.exports = __webpack_public_path__ + "static/media/assyrian_text_01.d9c99ee2.jpg";